import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bar-bg',
  templateUrl: './bar-bg.component.html',
  styleUrls: ['./bar-bg.component.css']
})
export class BarBgComponent implements OnInit {

  public source:string;
  
  constructor() { }

  ngOnInit() {
  }

}
